import 'css-chunk:src/app/containers/Home/OrganizationsView/EditOrgDrawer.scss';export default {
  "EditOrgDrawer": "_EditOrgDrawer_1ulaf_1",
  "form": "_form_1ulaf_1",
  "submitButton": "_submitButton_1ulaf_1"
};